import script from "./Profile.vue?vue&type=script&setup=true&lang=ts"
export * from "./Profile.vue?vue&type=script&setup=true&lang=ts"

import "./Profile.vue?vue&type=style&index=0&id=3fb05b1d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fb05b1d"]])

export default __exports__